import React, { Component } from "react";
import {
  Input,
  message,
  Select,
  Row,
  Col,
  Spin,
  Divider,
  Form as FormInicial,
} from "antd";
import { Form, FormItem, InputNumberItem, SelectItem, cuentaMask, ButtonItem, ErrorItem } from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import axios from "axios";
import { connect } from "react-redux";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import AgregarTipoDePoliza from "../../TiposDePolizas/AgregarTipoDePoliza/AgregarTipoDePoliza";

const { Option } = Select

class ContabilidadConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    modalAgregarCuentaContable: false,
    objetoCuentaContable: null,
    todasCuentaContable: null,
    objetoTiposDePolizasDiario: null,
    todasTiposDePolizas: null,
    objetoRegimenFiscal: null,
    todasRegimenFiscal: null,
    cuentaAgregando: null,
    modalAgregarTipoDePoliza: false,
    loading: false
  }
  componentDidMount() {
    this.consultarConfiguracion()
  }
  onFinish(values) {
    this.setState({ loading: true })
    axios
      .post(
        "empresas/editarConfiguracionContabilidad",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuracion");
        } else {
          message.error("Hubo un error y no se modifico la configuracion");
        }
      });
  }
  async consultarConfiguracion() {
    this.setState({ loading: true })
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentaContable: res.data });
          this.setState({
            objetoCuentaContable: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "regimenfiscal/selectRegimenesFiscales",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasRegimenFiscal: res.data });
          this.setState({
            objetoRegimenFiscal: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "tiposdepolizas/selectTiposDePolizas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasTiposDePolizas: res.data });
          this.setState({
            objetoTiposDePolizasDiario: res.data.map((value) => {
              if (value.tipoDePolizaId === 1 || value.tipoDePolizaId === 2) {
                return null;
              }
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "empresas/selectConfiguracionContabilidad",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro configuracion de esta empresa");
        } else {
          this.formRef.current.setFieldsValue({
            cuentaIntercentroId:
              res.data.cuentaIntercentroId,
            cuentaUtilidadCambiariaId:
              res.data.cuentaUtilidadCambiariaId,
            cuentaDescuentoComprasId: res.data.cuentaDescuentoComprasId,
            cuentaDescuentoVentasId: res.data.cuentaDescuentoVentasId,
            cuentaDescuentoVentasTasa0Id: res.data.cuentaDescuentoVentasTasa0Id,
            cuentaDescuentoVentasExentoId: res.data.cuentaDescuentoVentasExentoId,
            cuentaPerdidaCambiariaId:
              res.data.cuentaPerdidaCambiariaId,
            regimenFiscalId:
              res.data.regimenFiscalId,
            tipoDePolizaDiarioCCId:
              res.data.tipoDePolizaDiarioCCId,
            tipoDePolizaDiarioTECId:
              res.data.tipoDePolizaDiarioTECId,
            tipoDePolizaDiarioIId:
              res.data.tipoDePolizaDiarioIId,
            cuentaAjusteFacturasId:
              res.data.cuentaAjusteFacturasId,
            cuentaAjusteConciliacionId:
              res.data.cuentaAjusteConciliacionId,
            ajusteMax:
              res.data.ajusteMax,
            ajusteMaxConciliacion:
              res.data.ajusteMaxConciliacion,
            regimenesFiscalesAdicionales: res.data.regimenesFiscalesAdicionales,
          });
        }
      });
    this.setState({ loading: false })
  }
  abrirAgregarCuentaContable(cuentaAgregando) {
    this.setState({ modalAgregarCuentaContable: true, cuentaAgregando });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarConfiguracion().then(() => {
      if (typeof codigo === "string") {
        this.formRef.current.setFieldsValue({ [this.state.cuentaAgregando]: codigo });
        this.setState({ cuentaAgregando: null });
      }
    });
  }
  abrirAgregarTipoDePoliza() {
    this.setState({ modalAgregarTipoDePoliza: true });
  }
  cerrarAgregarTipoDePoliza(codigo) {
    this.setState({ modalAgregarTipoDePoliza: false });
    this.consultarConfiguracion();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    return (
      <>
        <Spin spinning={this.state.loading}>
          <Form
            name="contabilidadConfiguracion"
            layout
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
            ref={this.formRef}
          >
            <Row gutter={[16, 0]}>
              {/* Columna Cuentas Contables */}
              <Col xs={24} md={14}>
                <Row>
                  <DynamicCardForm
                     title={"Cuentas Contables"}
                    style={{ maxWidth: '98%', margin: '0 auto 12px auto' }}
                  >
                    <Row gutter={[16, 0]}>
                      <Col xs={24}>
                        <FormItem margin label='Cuenta Intercentro'
                           labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaIntercentroId" noStyle required>
                              <SelectItem placeholder="Cuenta Intercentro" width="90%">
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaIntercentroId')}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Cuenta Utilidad Cambiaria'
                         labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaUtilidadCambiariaId" noStyle required>
                              <SelectItem placeholder="Cuenta Utilidad Cambiaria" width="90%">
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaUtilidadCambiariaId')}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Cuenta Pérdida Cambiaria'
                           labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaPerdidaCambiariaId" noStyle required>
                              <SelectItem placeholder="Cuenta Pérdida Cambiaria" width="90%">
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaPerdidaCambiariaId')}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Cuenta Ajuste Facturas'
                          labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaAjusteFacturasId" noStyle required>
                              <SelectItem placeholder="Cuenta Ajuste Facturas" width="90%">
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaAjusteFacturasId')}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Cuenta Ajuste Conciliación Bancaria'
                          tooltip="Cuenta contrapartida para las pólizas de ajuste automáticas de conciliación bancaria. Si se deja en blanco, se debe elegir al momento de generar el ajuste."
                          labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaAjusteConciliacionId" noStyle>
                              <SelectItem placeholder="Cuenta Ajuste Conciliación Bancaria" width="90%" allowClear>
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaAjusteConciliacionId')}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Cuenta Descuento Compras'
                          labelCol={{ span: 10 }} wrapperCol={{ span: 14}}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaDescuentoComprasId" noStyle required>
                              <SelectItem placeholder="Cuenta Descuento Compras" width="90%">
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaDescuentoComprasId')}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Cuenta Descuento Ventas'
                           labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaDescuentoVentasId" noStyle required>
                              <SelectItem placeholder="Cuenta Descuento Ventas" width="90%">
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaDescuentoVentasId')}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Cuenta Descuento Ventas Tasa 0%'
                           labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaDescuentoVentasTasa0Id" noStyle>
                              <SelectItem placeholder="Cuenta Descuento Ventas Tasa 0%" width="90%">
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaDescuentoVentasTasa0Id')}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Cuenta Descuento Ventas Exento'
                           labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="cuentaDescuentoVentasExentoId" noStyle>
                              <SelectItem placeholder="Cuenta Descuento Ventas Exento" width="90%">
                                {this.state.objetoCuentaContable}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={() => this.abrirAgregarCuentaContable('cuentaDescuentoVentasExentoId')}
                            />
                          </Input.Group>
                        </FormItem>
                      </Col>
                    </Row>
                  </DynamicCardForm>
                </Row>
                <Row>
                <DynamicCardForm
                    title={"Régimen"}
                    style={{ maxWidth: '98%', margin: '0 auto 12px auto' }}
                  >
                    <Row gutter={[16, 0]}>
                      <Col xs={24}>
                        <FormItem
                          label="Régimen Fiscal"
                          name="regimenFiscalId"
                          margin
                          required
                          labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}
                        >
                          <SelectItem placeholder="Régimen Fiscal">
                            {this.state.objetoRegimenFiscal}
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col xs={24}>
                       <Divider style={{ margin: '30px 0px 0px 0', fontSize: 13, fontWeight: 'bold' }}> Adicionales</Divider>
                        <FormInicial.List noStyle name="regimenesFiscalesAdicionales">
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, fieldKey, ...restField }) => (
                                <Row key={key} gutter={8} align="middle">
                                  <Col span={20}>
                                    <FormItem
                                      {...restField}
                                      label="Régimen"
                                      name={[name, "regimenFiscalId"]}
                                      fieldKey={[fieldKey, "regimenFiscalId"]}
                                      required
                                      margin
                                      labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}
                                    >
                                      <SelectItem placeholder="Régimen Fiscal">
                                        {this.state.objetoRegimenFiscal}
                                      </SelectItem>
                                    </FormItem>
                                  </Col>
                                  
                                  <Col flex="28px">
                                  <div style={{ textAlign: 'center' }}>
                                        <ButtonItem
                                          rojo2
                                          icon={<DeleteOutlined />}
                                          onClick={() => remove(name)}
                                          
                                          lessTime
                                        />
                                      </div>
                                    </Col>
                                </Row>
                              ))}
                              <FormItem noStyle>
                                {fields.length < 3 ? (
                                     <div style={{ textAlign: "center", marginTop: 10, maxWidth: 300, marginLeft: 'auto', marginRight: 'auto' }}>
                                        <ButtonItem
                                            cyan
                                            type="primary"
                                            onClick={() => {
                                              if (fields.length < 3) {
                                                add()
                                              } else {
                                                message.warning('No se pueden agregar más de 3 regímenes fiscales adicionales')
                                              }
                                            }}
                                            block
                                            icon={<PlusOutlined />}
                                          >
                                            Agregar Régimen
                                        </ButtonItem>
                                     </div>
                                 
                                ) : null}
                              </FormItem>
                            </>
                          )}
                        </FormInicial.List>
                      </Col>
                    </Row>
                  </DynamicCardForm>

                 
                </Row>
              </Col>
              {/* Columna izquierda: Régimen Fiscal + Cuentas Contables */}
              <Col xs={24} md={10}>
                <Row>
                   <DynamicCardForm
                    title={"Pólizas"}
                    style={{ maxWidth: '98%', margin: '0 auto 12px auto' }}
                  >
                    <Row gutter={[16, 0]}>
                      <Col xs={24}>
                        <FormItem
                          label="Ajuste Máx."
                          name="ajusteMax"
                          margin number required
                          labelCol={{ span: 9 }} wrapperCol={{ span: 14 }}
                        >
                          <InputNumberItem placeholder="Ajuste Máx." masMenos />
                        </FormItem>
                        <FormItem
                          label="Ajuste Máx. Conciliación"
                          name="ajusteMaxConciliacion"
                          tooltip="Diferencia máxima de conciliación bancaria que se puede ajustar automáticamente con una póliza de ajuste. En blanco usa $0.50 por defecto."
                          margin number
                          labelCol={{ span: 9 }} wrapperCol={{ span: 14 }}
                        >
                          <InputNumberItem placeholder="0.50 por defecto" masMenos />
                        </FormItem>
                        <FormItem margin label='Póliza Diario Caja Chica'
                          tooltip="Elegir pólizas de diario solamente"
                          labelCol={{ span: 9 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="tipoDePolizaDiarioCCId" required noStyle>
                              <SelectItem placeholder="Tipo de Póliza Diario Caja Chica" width="90%">
                                {this.state.objetoTiposDePolizasDiario}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={this.abrirAgregarTipoDePoliza.bind(this)}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Póliza Diario Traspasos'
                          tooltip="Elegir pólizas de diario solamente"
                          labelCol={{ span: 9 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="tipoDePolizaDiarioTECId" required noStyle>
                              <SelectItem placeholder="Tipo de Póliza Diario Traspasos" width="90%">
                                {this.state.objetoTiposDePolizasDiario}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={this.abrirAgregarTipoDePoliza.bind(this)}
                            />
                          </Input.Group>
                        </FormItem>
                        <FormItem margin label='Póliza Diario Inventario'
                          tooltip="Elegir pólizas de diario solamente"
                          labelCol={{ span: 9 }} wrapperCol={{ span: 14 }}
                        >
                          <Input.Group compact>
                            <FormItem name="tipoDePolizaDiarioIId" required noStyle>
                              <SelectItem placeholder="Tipo de Póliza Diario Inventario" width="90%">
                                {this.state.objetoTiposDePolizasDiario}
                              </SelectItem>
                            </FormItem>
                            <ButtonItem
                              blanco icon={<PlusOutlined />} style={{ width: "10%", minWidth: 32 }}
                              onClick={this.abrirAgregarTipoDePoliza.bind(this)}
                            />
                          </Input.Group>
                        </FormItem>

                      </Col>
                    </Row>
                  </DynamicCardForm>

                </Row>
              </Col>

              
            </Row>

            <div style={{display: 'flex', justifyContent: 'flex-end',padding: '12px 8px',borderTop: '1px solid #f0f0f0',flexShrink: 0}}>
                <ButtonItem
                    cyan
                    type="primary"
                    htmlType="submit"
                    style={{
                        minWidth: 120,
                        height: 30,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    Guardar Configuración
                </ButtonItem>
            </div>
          </Form>
          <AgregarTipoDePoliza
            visible={this.state.modalAgregarTipoDePoliza}
            cerrarAgregarTipoDePoliza={this.cerrarAgregarTipoDePoliza.bind(this)}
          />
          <AgregarCuentaContable
            visible={this.state.modalAgregarCuentaContable}
            cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(
              this
            )}
          />
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ContabilidadConfiguracion);
